export enum LearningResourceRequestStatusEnum {
  Pending = 'pending',
  Accepted = 'accepted',
  Declined = 'declined',
}

export const LearningResourceRequestStatusEnumLabels: Record<LearningResourceRequestStatusEnum, string> = {
  [LearningResourceRequestStatusEnum.Pending]: 'Pendiente',
  [LearningResourceRequestStatusEnum.Accepted]: 'Aceptada',
  [LearningResourceRequestStatusEnum.Declined]: 'Rechazada',
};
